module.exports = __webpack_public_path__ + "img/signContract.a376d7fe.png";